// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"98":"84d184b8","881":"da544907"}[chunkId] + ".css";
};